export default __webpack_public_path__ + "static/media/blog24.e36e5bdd.jpg";